var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex justify-center py-0",attrs:{"color":"primary white--text","fixed":""}},[_c('v-icon',{staticClass:"white--text mr-2",attrs:{"small":""}},[_vm._v("mdi-copyright")]),_c('span',{staticClass:"overline"},[_vm._v(" Almeida Technologies LTDA ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }